












import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Validator, FieldError } from 'vee-validate';

import AddressComponent from '@/shared/components/Address/Address.vue';

import Address from '@/classes/Address';

const CustomerModule = namespace('App/Customer');

@Component({
  components: {
    Address: AddressComponent
  }
})
export default class DeliveryAddress extends Vue {
  @Prop({
    default: () => ({
      street_name: '',
      street_number: '',
      city: '',
      neighborhood: '',
      state: '',
      postal_code: '',
      ibge_code: '',
    }),
  }) private readonly deliveryAddress!: Address;

  @CustomerModule.Mutation('setDeliveryAddress')
  private setDeliveryAddress: Function;

  private validator = new Validator();

  private validated: boolean = false;
  private deliveryAddressLocal: Address = new Address();

  private handleAddressChange (value: Address, fromLocal: boolean = false) {
    if (!fromLocal) {
      this.deliveryAddressLocal = value;
    }

    this.setDeliveryAddress({
      ...value,
      acta_address_id: undefined,
      is_default: false,
      is_billing: false,
      is_delivery: true,
      country: 'brasil',
    });
  }

  @Watch('deliveryAddressLocal', { deep: true })
  onChangeDeliveryAddress (value: Address) {
    this.handleAddressChange(value, true);

    if (this.validated) {
      this.validator.reset();
    }
  }

  validateAddress() {
    return new Promise(async (resolve: any, reject) => {
      const result = await this.validator.validateAll({
        ...this.deliveryAddress,
      });

      this.validated = true;

      result
        ? resolve()
        : reject();
    });
  }

  private zipCodeNotFound(): void {
    this.setDeliveryAddress({
      ...this.deliveryAddressLocal,
      street_name: '',
      street_number: '',
      city: '',
      neighborhood: '',
      state: '',
      ibge_code: '',
      is_delivery: true,
    });
  }

  mounted () {
    this.deliveryAddressLocal = Object.assign({}, this.deliveryAddress);
  }
}
